import React from 'react';
import { ZoneCircleProps } from './types';
import { colorByType, options } from './styles';
import { Circle } from '@react-google-maps/api';
import { ZoneLabel } from '@src/core/features/zones/components/zones-control/components';

const ZoneCircle: React.FC<ZoneCircleProps> = (props) => {
  const { zone } = props;
  
  const lat = Number(zone.centerLatitude);
  const lng = Number(zone.centerLongitude);

  if (isNaN(lat) || isNaN(lng)) return null;

  const color = colorByType[zone.zoneType];

  return (
    <React.Fragment>
      <ZoneLabel zone={zone}/>
      <Circle
        center={{ lat, lng }}
        radius={zone.radiusMeters}
        options={{ 
          ...options, 
          fillColor: color,
          fillOpacity: 0.3,
          strokeColor: color,
        }}
      />
    </React.Fragment>
  );
};

export default ZoneCircle;